import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useFetchVendorsThemeQuery, useUpdateVendorThemeMutation } from "../../../features/admin/vendorTheme/vendorThemeApi";

export default function EmployeeSetup() {
    const [selectedClient, setSelectedClient] = useState("");
    const [syncAppUsers, setSyncAppUsers] = useState(false);
    const [syncPanelUsers, setSyncPanelUsers] = useState(false);
    const [vendorsList, setVendorsList] = useState([]);
    const [vendorThemeData, setVendorThemeData] = useState(null);
    const [selectedVendorTheme, setSelectedVendorTheme] = useState(null);
    const [saveBtn, setSaveBtn] = useState(false);

    const [
        updateVendorTheme,
        {
            data: updateVendorThemeData,
            isLoading: updateVendorThemeIsLoading,
            isError: updateVendorThemeIsError,
            error: updateVendorThemeError,
        },
    ] = useUpdateVendorThemeMutation();

      const { refetch: vendorsThemeRefetch } =
        useFetchVendorsThemeQuery(sessionStorage.getItem("access_token")) || {};

    // Fetch Company List
    useEffect(() => {
        toast.remove();

        axios({
            method: "get",
            url: `${process.env.REACT_APP_BASE_URL}/admin/company`,
            headers: {
                Authorization: "Bearer " + sessionStorage.getItem("access_token"),
            },
        })
            .then((response) => {
                setVendorsList(response.data.body);
                sessionStorage.setItem("vendor_list", JSON.stringify(response.data));
            })
            .catch((error) => console.log(error));
    }, []);

    // Fetch Vendor Theme
    const {
        data: vendorsThemeDataAPI,
        isError: vendorsThemeIsError,
        isLoading: vendorsThemeIsLoading,
    } = useFetchVendorsThemeQuery(sessionStorage.getItem("access_token")) || {};

    useEffect(() => {
        if (vendorsThemeIsError) {
            return toast.error("Oops, some error occurred", {
                id: "errorId",
                autoClose: 1000,
            });
        }
        if (vendorsThemeDataAPI) {
            setVendorThemeData(vendorsThemeDataAPI.body);
        }
    }, [vendorsThemeIsError, vendorsThemeDataAPI]);
    const handleUpdateVendorTheme = (e) => {
        e.preventDefault();

        const tenantTheme = {
            ...selectedVendorTheme.theme,
            sync_app_users: syncAppUsers,
            sync_panel_users: syncPanelUsers,
        };

        console.log("tenant",
            {
                tenant_name: selectedClient,
                theme: tenantTheme,
            }
        );

        const vendorData = vendorThemeData?.find(
            (vendor) => vendor.tenant_id == selectedClient
        );


        if(vendorData)
        {
            updateVendorTheme({
                token: sessionStorage.getItem("access_token"),
                params: selectedClient,
                body: {
                    tenant_name: vendorData.tenant_name,
                    theme: tenantTheme,
                },
            });
        }
    };

    useEffect(()=>{
    if (updateVendorThemeData) {
        toast.success(`${updateVendorThemeData.message}`, {
            id: "vendorThemeUpdateSuccessfully",
        });
        setSaveBtn(false);
        setSelectedClient("");
        setSelectedVendorTheme(null);
        setSyncAppUsers(false);
        setSyncPanelUsers(false);
        vendorsThemeRefetch()
    }

    if (updateVendorThemeIsError) {
        toast.error(`${updateVendorThemeError.data.message}`, {
            id: "vendorThemeAddError",
        });
    }
    },[updateVendorThemeData, updateVendorThemeIsError])



    return (
        <div className="page-content">
            <div className="card p-6 rounded-lg shadow-md bg-white">

                {/* Page Header */}
                <div className="flex justify-between items-center mb-6">
                    <h3 className="text-xl font-semibold card-title">Employee Setup</h3>

                    {saveBtn && (
                        <button
                            onClick={(e) => handleUpdateVendorTheme(e)}
                            className="bg-primary text-white px-5 py-2 rounded-md shadow hover:bg-primary/90 transition-all"
                        >
                            Save
                        </button>
                    )}
                </div>

                {/* Filters Section */}
                <div className="grid md:grid-cols-3 grid-cols-1 gap-6">

                    {/* Client Dropdown */}
                    <div className="flex flex-col w-full">
                        <label className="mb-1 font-medium text-gray-700">Select Client</label>
                        <select
                            className="border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-primary focus:border-primary"
                            value={selectedClient}
                            onChange={(e) => {
                                const tenantId = e.target.value;
                                setSelectedClient(tenantId);

                                const vendorData = vendorThemeData?.find(
                                    (vendor) => vendor.tenant_id == tenantId
                                );

                                if (vendorData) {
                                    setSyncAppUsers(vendorData?.theme?.sync_app_users);
                                    setSyncPanelUsers(vendorData?.theme?.sync_panel_users);
                                    setSelectedVendorTheme(vendorData);
                                    console.log(vendorData)
                                } else {
                                    setSelectedVendorTheme(null);
                                    setSyncAppUsers(false);
                                    setSyncPanelUsers(false);
                                }
                            }}
                        >
                            <option value="">Select Client...</option>
                            {vendorsList.map((vendor) => (
                                <option key={vendor.tenant_id} value={vendor.tenant_id}>
                                    {vendor.name.charAt(0).toUpperCase() + vendor.name.slice(1)}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Sync to App Users Toggle */}
                    <div className="flex flex-col">
                        <label className="mb-2 font-medium text-gray-700">Sync to App Users</label>
                        <button
                            disabled={!selectedClient}
                            onClick={() => {
                                setSyncAppUsers(prev => !prev);
                                setSaveBtn(true);
                            }}
                            className={`
        w-16 h-8 rounded-full transition-all duration-300 relative
        ${!selectedClient ? "bg-gray-200 cursor-not-allowed" : syncAppUsers ? "bg-primary" : "bg-gray-300"}
    `}
                        >
                            <span
                                className={`
            absolute top-1/2 left-1 -translate-y-1/2 w-6 h-6 bg-white rounded-full shadow-md 
            transition-all duration-300 
            ${syncAppUsers ? "translate-x-8" : ""}
        `}
                            ></span>
                        </button>

                    </div>

                    {/* Sync to Panel Users Toggle */}
                    <div className="flex flex-col">
                        <label className="mb-2 font-medium text-gray-700">Sync to Panel Users</label>

                        <button
                            disabled={!selectedClient}
                            onClick={() => {
                                setSyncPanelUsers(prev => !prev);
                                setSaveBtn(true);
                            }}
                            className={`
        w-16 h-8 rounded-full transition-all duration-300 relative
        ${!selectedClient ? "bg-gray-200 cursor-not-allowed" : syncPanelUsers ? "bg-primary" : "bg-gray-300"}
    `}
                        >
                            <span
                                className={`
            absolute top-1/2 left-1 -translate-y-1/2 w-6 h-6 bg-white rounded-full shadow-md 
            transition-all duration-300 
            ${syncPanelUsers ? "translate-x-8" : ""}
        `}
                            ></span>
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
}
